import {
  CommandBar,
  DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  FontIcon,
  ICommandBarItemProps,
  IDetailsColumnProps,
  IDetailsListProps,
  IDetailsListStyles,
  IGroupHeaderProps,
  IRawStyle,
  IRenderFunction,
  Icon,
  IconButton,
  Link,
  PanelType,
  SelectionMode,
  Separator,
  Stack,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import { _onRenderHeaderAllheight } from "../../../utils/helpers/helpers";
import COLORES from "../../../utils/theme/colores";
import { IDetalleLineaBase } from "../../../Interfaces/LineaBase/IProcesos";
import HeaderTable from "../../../components/generic/HeaderTable";
import themeBase from "../../../utils/theme/themeBase";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { useBoolean } from "@fluentui/react-hooks";
import JerarquiaControlesVista from "./JerarquiaControlesVista";
import AccionesMejoraVista from "./AccionesMejoraVista";
import EvaluacionesVista from "./EvaluacionesVista";
import IconHelper from "../../../utils/helpers/iconHelper";
import EquipoEvaluadorVista from "./EquipoEvaluadorVista";
import NuevoRegistro from "./NuevoRegistro";

function TablaLineaBase() {
  const [
    isOpenEditarRiesgo,
    { setTrue: openEditarRiesgo, setFalse: dismissEditarRiesgo },
  ] = useBoolean(false);
  const [
    isOpenMejoras,
    { setTrue: openEditarMejoras, setFalse: dismissEditarMejoras },
  ] = useBoolean(false);
  const [
    isOpenControles,
    { setTrue: openEditarControles, setFalse: dismissEditarControles },
  ] = useBoolean(false);
  const [
    isOpenEquipo,
    { setTrue: openEditarEquipo, setFalse: dismissEditarEquipo },
  ] = useBoolean(false);
  const [
    isOpenNuevo,
    { setTrue: openNuevo, setFalse: dismissNuevo },
  ] = useBoolean(false);

  const _columnsDetalleItems = [
    {
      key: "actividad",
      name: "Actividad",
      fieldName: "actividad",
      minWidth: 120,
      maxWidth: 120,
      // onRender: (item: IIPercItemsColum) => <></>,
      isResizable: true,
      isMultiline: true,
      // onRender: (item: IIPercItemsColum) => (ItemRenderAux(item.peligro)),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          borderRight: "1px solid #fff",
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "tarea",
      name: "Tarea",
      fieldName: "tarea",
      minWidth: 80,
      maxWidth: 80,
      // onRender: (item: IIPercItemsColum) => <></>,
      isResizable: true,
      isMultiline: true,
      // onRender: (item: IIPercItemsColum) => (ItemRenderAux(item.peligro)),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          borderRight: "1px solid #fff",
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "peligro",
      name: "Peligro",
      fieldName: "peligro",
      minWidth: 150,
      maxWidth: 150,
      // onRender: (item: IIPercItemsColum) => <></>,
      isResizable: true,
      isMultiline: true,
      // onRender: (item: IIPercItemsColum) => (ItemRenderAux(item.peligro)),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          borderRight: "1px solid #fff",
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "riesgo",
      name: "Riesgo",
      fieldName: "riesgo",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
      // onRender: (item: IIPercItemsColum) => ItemRenderAux(item.riesgo),
      onRenderHeader: _onRenderHeaderColum,
      styles: {
        root: {
          background: COLORES.IPERC.Red,
          borderRight: "1px solid #fff",
          selectors: { ":hover": { background: COLORES.IPERC.Red } },
        },
      },
    },
    {
      key: "valorA",
      name: "F",
      fieldName: "valorA",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>C</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.A),
      onRenderHeader: RenderTitleIpercA,
      styles: {
        root: { background: COLORES.IPERC.A, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "M",
      name: "S",
      fieldName: "M",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>4</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.M),
      onRenderHeader: RenderTitleIpercM,
      styles: {
        root: { background: COLORES.IPERC.M, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "B",
      name: `V`,
      fieldName: "B",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>18</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.B),
      onRenderHeader: RenderTitleIpercB,
      styles: {
        root: { background: COLORES.IPERC.B, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "medidascontrol",
      name: "Jer. Controles",
      fieldName: "medidascontrol",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isMultiline: true,
      onRender: (item: IDetalleLineaBase) => (
        <Stack horizontalAlign="center">
          <div>
            <TooltipHost content={`Editar`}>
              <Icon
                iconName="Trackers"
                className={themeBase.classNamesIcon.iconFont}
                style={{ color: COLORES.Bases.primary }}
                onClick={() => {
                  openEditarControles();
                }}
              />
            </TooltipHost>
          </div>
        </Stack>
      ),
      // onRender: (item: IIPercItemsColum) => ItemRenderAux(item.medida),
      // onRenderHeader: _onRenderHeaderColum,
      // styles: { root: { background: COLORES.IPERC.Red, selectors: { ':hover': { background: COLORES.IPERC.Red, } } } }
    },
    {
      key: "accionesMejora",
      name: "Acc. Mejora",
      fieldName: "accionesMejora",
      minWidth: 80,
      maxWidth: 90,
      isResizable: true,
      isMultiline: true,
      onRender: (item: IDetalleLineaBase) => (
        <Stack horizontalAlign="center">
          <div>
            <TooltipHost content={`Editar`}>
              <Icon
                iconName="Assign"
                className={themeBase.classNamesIcon.iconFont}
                style={{ color: COLORES.Bases.primary }}
                onClick={() => {
                  openEditarMejoras();
                }}
              />
            </TooltipHost>
          </div>
        </Stack>
      ),
      // onRender: (item: IIPercItemsColum) => ItemRenderAux(item.medida),
      // onRenderHeader: _onRenderHeaderColum,
      // styles: { root: { background: COLORES.IPERC.Red, selectors: { ':hover': { background: COLORES.IPERC.Red, } } } }
    },
    {
      key: "ma",
      name: "F",
      fieldName: "ma",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>C</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MA),
      onRenderHeader: RenderTitleIpercA,
      styles: {
        root: { background: COLORES.IPERC.A, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "mm",
      name: `S`,
      fieldName: "mm",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>4</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MM),
      onRenderHeader: RenderTitleIpercM,
      styles: {
        root: { background: COLORES.IPERC.M, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "mb",
      name: `V`,
      fieldName: "mb",
      minWidth: 15,
      maxWidth: 15,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => <>18</>,
      // onRender: (item: IIPercItemsColum) => ItemRenderIper(item.MB),
      onRenderHeader: RenderTitleIpercB,
      styles: {
        root: { background: COLORES.IPERC.B, borderRight: "1px solid #fff" },
      },
    },
    {
      key: "op",
      name: "",
      fieldName: "op",
      minWidth: 30,
      maxWidth: 30,
      isResizable: true,
      onRender: (item: IDetalleLineaBase) => (
        <Stack horizontalAlign="center">
          <div>
            <TooltipHost content={`Editar`}>
              <Icon
                iconName="edit"
                className={themeBase.classNamesIcon.iconFont}
                style={{ color: COLORES.Bases.primary }}
                onClick={() => {
                  openEditarRiesgo();
                }}
              />
            </TooltipHost>
            {/* <TooltipHost content={`Quitar`}>
                  <Icon
                      iconName="delete"
                      // className="ms-fontSize-14"
                      className={themeBase.classNamesIcon.iconFont}
                      style={{ cursor: 'pointer', color: COLORES.Icons.delete }}
                  />
              </TooltipHost> */}
          </div>
        </Stack>
      ),
    },
  ];

  const _onRenderDetailsFooter: IDetailsListProps["onRenderDetailsFooter"] = (
    props
  ) => {
    // if (props) {
    //     if (gruposItems.length === 0)
    //         return (
    //             <h4 style={{
    //                 textAlign: 'center',
    //                 verticalAlign: 'center',
    //                 background: themeBase.colors_Bases.HeaderGroup,
    //                 width: '90%',
    //                 padding: 10
    //             }}>
    //                 Sin Datos
    //             </h4>
    //         )
    //     if (ArrayItems.length === 0)
    //         return null
    // }
    return null;
  };

  const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
    props
  ) => {
    const customStyles: Partial<IDetailsListStyles> = {};
    customStyles.root = {
      alignContent: "center",
      background: "#ddd",
    };
    if (props) {
      return <DetailsHeader {...props} styles={customStyles} />;
    }
    return null;
  };
  const _CommandBarItem: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {openNuevo()},
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {},
    },
    {
      ...IconHelper.ICON_GROUP_PEOPLE,
      onClick: () => {openEditarEquipo()},
    },
  ];
  const _CommandBarItemRight: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {},
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {},
    },
  ];

  return (
    <>
      <Stack padding={5}>
        <CommandBar
          items={_CommandBarItem}
          farItems={[]}
          styles={themeBase.commadStylesWithPadding}
        />
      </Stack>
      <div className="ms-Grid" dir="ltr">
        {/* <HeaderTable
          title="Gestión de IPERC Base"
          subTitle="Proceso: Tecnología de Información"
          horizontalAlign="end"
          iconName="Dialpad"
        /> */}
        {/* <Separator>
          <TooltipHost content={`Equipo Evaluador`}>
            <Icon iconName="Group" style={{ cursor: "pointer" }} />
          </TooltipHost>
        </Separator> */}
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg12">
            {/* {HelpersIpercBase.LoadingData(isLoadingData)} */}
            <DetailsList
              items={
                [
                  {
                    DetalleId: "1",
                    actividad: "Gobierno tecnología de información",
                    tarea: "Labores de oficina",
                    peligro: "Tránsito en pisos resbaladizos y disparejos",
                    riesgo: "Caída al mismo nivel",
                    evaluacion: true,
                    controles: 2,
                    mejoras: true,
                    reevaluacion: true,
                  },
                  {
                    DetalleId: "1",
                    actividad: "Gobierno tecnología de información",
                    tarea: "Labores de oficina",
                    peligro: "Tránsito en pisos resbaladizos y disparejos",
                    riesgo: "Caída al mismo nivel",
                    evaluacion: true,
                    controles: 2,
                    mejoras: true,
                    reevaluacion: true,
                  },
                ] as IDetalleLineaBase[]
              }
              //   groups={gruposItems}
              columns={_columnsDetalleItems}
              selectionMode={SelectionMode.none}
              //   onRenderDetailsHeader={_onRenderDetailsHeader}
              onRenderDetailsFooter={_onRenderDetailsFooter}
              // onRenderRow={_onRenderRow}
              layoutMode={DetailsListLayoutMode.justified}
              // groupProps={groupedListProps}
              //   groupProps={{ onRenderHeader: onRenderHeader }}
              compact={true}
              styles={_onRenderHeaderAllheight}
            />
          </div>
        </div>
      </div>
      {/* Editar Peligro de Actividad */}
      <PanelGenerico
        isOpen={isOpenEditarRiesgo}
        onDismiss={dismissEditarRiesgo}
        HeaderTitlesText={{
          title: "Evaluacion de Riesgo",
          // subTitle: "Edite los valores de evaluacion",
        }}
        enabledHeader
        // registrar={ActulizarPeligro}
        // objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissEditarRiesgo}
      >
        <br />
        <br />
        <EvaluacionesVista RiesgoId={""} />
      </PanelGenerico>
      {/* Editar Peligro de Jerarquias de controles */}
      <PanelGenerico
        isOpen={isOpenControles}
        onDismiss={dismissEditarControles}
        HeaderTitlesText={{
          title: "Jerarquias de controles",
          //   subTitle: "Edite los valores de evaluacion",
        }}
        enabledHeader
        // registrar={ActulizarPeligro}
        // objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissEditarControles}
      >
        <JerarquiaControlesVista TareaId={""} />
      </PanelGenerico>
      {/* Editar Peligro de Aciones de mejora */}
      <PanelGenerico
        isOpen={isOpenMejoras}
        onDismiss={dismissEditarMejoras}
        HeaderTitlesText={{
          title: "Aciones de mejora",
          //   subTitle: "Edite los valores de evaluacion",
        }}
        enabledHeader
        // registrar={ActulizarPeligro}
        // objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissEditarMejoras}
        panelType={PanelType.smallFixedFar}
      >
        <AccionesMejoraVista TareaId={""} />
      </PanelGenerico>
      {/* Editar Peligro de Actividad */}
      <PanelGenerico
        isOpen={isOpenEquipo}
        onDismiss={dismissEditarEquipo}
        HeaderTitlesText={{
          title: "Euipo Evaluador",
          //   subTitle: "Edite los valores de evaluacion",
        }}
        enabledHeader
        enabledFooter
        // registrar={ActulizarPeligro}
        // objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissEditarEquipo}
        // panelType={PanelType.smallFixedFar}
      >
        <EquipoEvaluadorVista plantillaId={""} />
      </PanelGenerico>
      {/* Nuevo */}
      <PanelGenerico
        isOpen={isOpenNuevo}
        onDismiss={dismissNuevo}
        HeaderTitlesText={{
          title: "Nuevo Registro",
          //   subTitle: "Edite los valores de evaluacion",
        }}
        enabledHeader
        // registrar={ActulizarPeligro}
        // objectRenderBodyHelp={PeligroModelPUT}
        cancelar={dismissNuevo}
        // panelType={PanelType.smallFixedFar}
      >
        <NuevoRegistro ActividadId={""}/>
      </PanelGenerico>
    </>
  );
}

export default TablaLineaBase;

const _onRenderHeaderColum = (
  colProps?: IDetailsColumnProps,
  defaultRender?: IRenderFunction<IDetailsColumnProps>
): JSX.Element | null => (
  <Stack
    style={{
      color: COLORES.IPERC.whiteNumber,
      fontWeight: "bold",
      fontSize: "11px",
    }}
  >
    {colProps?.column.name}{" "}
  </Stack>
);

const RenderTitleIpercA = (
  colProps?: IDetailsColumnProps,
  defaultRender?: IRenderFunction<IDetailsColumnProps>
): JSX.Element | null => (
  <div style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
    {colProps?.column.name}
  </div>
);

const RenderTitleIpercM = (
  colProps?: IDetailsColumnProps,
  defaultRender?: IRenderFunction<IDetailsColumnProps>
): JSX.Element | null => (
  <Stack style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
    {colProps?.column.name}
  </Stack>
);

const RenderTitleIpercB = (
  colProps?: IDetailsColumnProps,
  defaultRender?: IRenderFunction<IDetailsColumnProps>
): JSX.Element | null => (
  <Stack style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
    {colProps?.column.name}
  </Stack>
);

const ItemRenderAux = (text: string) => (
  <Stack
    className="ms-fontSize-10"
    horizontal
    horizontalAlign="space-between"
    verticalAlign="center"
  >
    {text}
  </Stack>
);
const ItemRenderIper = (text: string) => {
  if (text == "")
    return (
      <FontIcon
        iconName="ToggleBorder"
        style={{ color: COLORES.Icons.delete }}
      />
    );
  return (
    <span style={{ color: COLORES.IPERC.number, fontWeight: "bold" }}>
      {text}
    </span>
  );
};
